import { CAARepository } from '../repositories/CAARepository'

export function ListSemesterCAAReport(caaRepositoryAdapter: CAARepository) {
  return async function ({
    patientId,
    year,
    semester
  }: {
    patientId: string
    year: string
    semester: string
  }) {
    return await caaRepositoryAdapter.listSemesterCAAReport(
      patientId,
      year,
      semester
    )
  }
}
